module.exports = __webpack_public_path__ + "img/noIe.cbb18436.png";